import { useSelector } from 'react-redux';

/** Who may change Cold Chain setup: org admins/managers and Instance Admins. Shared by the page and the vehicle drawer. */
export default function useCanManageColdChain() {
  const orgRole = useSelector((s) => s.org?.role);
  const isSultan = useSelector((s) => s.sultan?.isSultan);
  return orgRole === 'admin' || orgRole === 'manager' || Boolean(isSultan);
}
